import { DOC_FLOW_STATUSES } from '../../../constants/docFlow'
import { ROUTE_PATH_LIST } from '../../../constants/route'
import { useAsyncCallback } from '../../../hooks'
import {
  EntityProfileHeader,
  EntityProfileHeaderTitleWithStatus,
} from '../../Entity'
import { useDocFlowContext } from '../DocFlow.hooks'
import { DocFlowProfileHeaderActions } from '../DocFlowProfileHeaderActions'
import { DocFlowProfileHeaderContent } from '../DocFlowProfileHeaderContent'

import { DOC_FLOW_PROFILE_HEADER_EDIT_TITLE_BTN_QA_NAME } from './DocFlowProfileHeader.constants'
import {
  useDocFlowProfileHeaderEditTitle,
  useDocFlowProfileHeaderInfoItems,
} from './DocFlowProfileHeader.hooks'

import * as styles from './DocFlowProfileHeader.module.css'

import DocFlowIcon from '../../../icons/doc-splitting.svg'

function DocFlowProfileHeader() {
  const {
    activePhase,
    docFlow,
    docFlowInitiated,
    footerProps,
    handleCloseModal,
    handleNextPhase,
    handleUpdateDocFlow,
    setModal,
  } = useDocFlowContext()

  const { handleEditTitle, handleOpenEditTitleModal } =
    useDocFlowProfileHeaderEditTitle()

  const { infoItemsProps } = useDocFlowProfileHeaderInfoItems({
    onEditTitle: handleEditTitle,
  })

  const handleClickArchive = useAsyncCallback(() => {
    return handleUpdateDocFlow(
      { archived: true },
      'Notification.DocFlowsTitleArchiveKey'
    ).then(data => {
      handleCloseModal()

      return data
    })
  }, [handleCloseModal, handleUpdateDocFlow])

  const handleClickRestore = useAsyncCallback(() => {
    return handleUpdateDocFlow(
      { archived: false },
      'Notification.DocFlowsRestoreArchiveKey'
    ).then(data => {
      handleCloseModal()

      return data
    })
  }, [handleCloseModal, handleUpdateDocFlow])

  const preparedFooterProps = {
    ...footerProps,
    Actions: DocFlowProfileHeaderActions,
    completedPhase: docFlow?.phase > activePhase,
    nextPhaseDisabled:
      !docFlow?.permissions.can_move_to_next_phase ||
      footerProps?.nextPhaseDisabled,
    selectedPhase: activePhase,
    onArchive: handleClickArchive,
    onNextPhase: handleNextPhase,
    onRestore: handleClickRestore,
  }

  const headerProps = {
    entityAvatarProps: {
      Icon: DocFlowIcon,
    },
    isArchived: docFlow?.archived,
    sectionBackUrl: `/${ROUTE_PATH_LIST.docFlows}`,
    statusProps: {
      id: docFlow?.status,
      statuses: DOC_FLOW_STATUSES,
    },
    text: docFlow?.name,
    textProps: {
      editable: !docFlow?.archived,
      editButtonQaName: DOC_FLOW_PROFILE_HEADER_EDIT_TITLE_BTN_QA_NAME,
    },
  }

  return (
    <EntityProfileHeader
      Content={DocFlowProfileHeaderContent}
      Header={EntityProfileHeaderTitleWithStatus}
      className={styles.profileHeader}
      footerProps={preparedFooterProps}
      headerProps={headerProps}
      infoItemsProps={infoItemsProps}
      isLoading={!docFlowInitiated}
      onClickEditTitleButton={handleOpenEditTitleModal}
      onCloseModal={handleCloseModal}
      onSetModal={setModal}
    />
  )
}

export default DocFlowProfileHeader
